import { Box, styled } from '@mui/material';
import findRoute from 'new/routing/routes';
import React from 'react';
import { LandingPageCommonProps, OfficeInfoNoAuth } from '../../types';
import { Link } from 'react-router';
import {
  commonLandingPageStyles,
  sectionLandingPageStyles,
  landingPageBtn,
} from '../../styles';
import { useIntl } from 'react-intl';
import { useExternalPatientsStore } from '../../hooks';
import { getPlanTypeFormatMessageProps } from '../../utils';

const Wrapper = styled(Box)(({ theme }) => ({
  ...commonLandingPageStyles,
  ...sectionLandingPageStyles,
  ...landingPageBtn,
  textAlign: 'center',
  '.container': {
    width: '90%',
    maxWidth: '1400px',
  },
  '.join-title': {
    fontSize: '2.5rem',
    lineHeight: '3rem',
    fontWeight: 'bold',
    width: '60%',
    margin: ' 0 auto',
    padding: '1rem 0',

    [theme.breakpoints.down(768)]: {
      width: '90%',
      fontSize: '1.8rem',
      lineHeight: '2rem',
    },
  },
  '.join-subhead': {
    fontSize: '1.2rem',
    color: '#727272',
    width: '80%',
    margin: '0 auto',
  },
  '.join-discount': {
    fontSize: '1.2rem',
    width: '80%',
    margin: '0 auto',
  },
}));

type Props = {
  officeData: OfficeInfoNoAuth;
  showJoinButton: boolean;
  smBusinessInfo?: {
    smbizBusinessInvites?: {
      discountPercentage?: number;
      groupCode?: string;
    };
  };
} & LandingPageCommonProps;

const JoinSection: React.FC<Props> = ({
  officeData,
  showJoinButton,
  smBusinessInfo,
  colorOneHex,
  colorTwoHex,
}) => {
  const { planType } = useExternalPatientsStore();
  const intl = useIntl();

  return (
    <Wrapper component="section" className="section-join">
      <Box className="container">
        <Box sx={{ color: `${colorOneHex}` }} className="join-title">
          {intl.formatMessage(
            getPlanTypeFormatMessageProps(
              'signup.externalLanding.join',
              planType,
            ),
          )}
        </Box>
        {!!smBusinessInfo && (
          <Box className="join-discount" style={{ color: colorOneHex }}>
            <u>
              {intl.formatMessage(
                { id: 'signup.externalLanding.join.discount' },
                {
                  discount:
                    smBusinessInfo?.smbizBusinessInvites?.discountPercentage,
                },
              )}
            </u>
          </Box>
        )}
        <Box className="join-subhead">
          {intl.formatMessage({ id: 'signup.externalLanding.joinSubhead' })}
        </Box>
        {showJoinButton && (
          <Link
            className="btn"
            to={`${findRoute('ExternalPatientSignup').path}?officeId=${
              officeData.data.id
            }${
              !!smBusinessInfo &&
              (smBusinessInfo?.smbizBusinessInvites?.groupCode == null ||
                smBusinessInfo?.smbizBusinessInvites?.groupCode == undefined)
                ? ''
                : '&groupCode=' +
                  smBusinessInfo?.smbizBusinessInvites?.groupCode
            }`}
            style={{
              backgroundColor: colorTwoHex,
              padding: '10px',
            }}
          >
            {intl.formatMessage({
              id: 'signup.externalLanding.hero.joinOurMembershipPlan.button',
            })}
          </Link>
        )}
      </Box>
    </Wrapper>
  );
};

export default JoinSection;
